import { setClientCookie } from '@/utils/setClientCookie';

export const getCookieValue = (key: string): string | null => {
  const encodedKey = encodeURIComponent(key);
  const pairs = document.cookie ? document.cookie.split('; ') : [];
  for (const pair of pairs) {
    const [rawName, ...rest] = pair.split('=');
    if (rawName !== encodedKey) continue;
    return rest.length > 0 ? decodeURIComponent(rest.join('=')) : '';
  }
  return null;
};

export const setCookieValue = (key: string, value: string) => {
  setClientCookie(key, value);
};

export const readPersistedTabIndex = (key: string): number | null => {
  let raw = getCookieValue(key);
  if (raw === null) {
    raw = window.localStorage.getItem(key);
  }
  if (raw === null) return null;

  const parsed = Number(raw);
  return Number.isInteger(parsed) ? parsed : null;
};

export const writePersistedTabIndex = (key: string, idx: number) => {
  const value = String(idx);
  setCookieValue(key, value);
  window.localStorage.setItem(key, value);
};
